import React, { Component } from "react";
import PropTypes from "prop-types";
var CurrencyFormat = require("react-currency-format");
export default class LoanBalanceInterviewQuestion extends Component {
  constructor(props) {
    super(props);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    if (
      this.props.lead.primaryGoal == "Purchase" ||
      this.props.lead.primaryGoal == "Renovation" ||
      this.props.lead.primaryGoal == "Other"
    ) {
      if (this.props.lead.loanBalance == null) {
        return (
          <div className="input-group-sm">
            <CurrencyFormat
              disabled
              isNumericString={true}
              className="form-control"
              thousandSeparator={true}
              prefix={"$"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                // formattedValue = $2,223
                // value ie, 2223
                this.props.onChangeLoanBalance(value);
              }}
            />
          </div>
        );
      } else {
        return (
          <div className="input-group-sm">
            <CurrencyFormat
              disabled
              isNumericString={true}
              className="form-control"
              value={this.props.lead.loanBalance}
              thousandSeparator={true}
              prefix={"$"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                // formattedValue = $2,223
                // value ie, 2223
                this.props.onChangeLoanBalance(value);
              }}
            />
          </div>
        );
      }
    } else {
      if (this.props.lead.loanBalance == null) {
        return (
          <div className="input-group-sm">
            <CurrencyFormat
              isNumericString={true}
              className="form-control"
              thousandSeparator={true}
              prefix={"$"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                // formattedValue = $2,223
                // value ie, 2223
                this.props.onChangeLoanBalance(value);
              }}
            />
          </div>
        );
      } else {
        return (
          <div className="input-group-sm">
            <CurrencyFormat
              isNumericString={true}
              className="form-control"
              value={this.props.lead.loanBalance}
              thousandSeparator={true}
              prefix={"$"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                // formattedValue = $2,223
                // value ie, 2223
                this.props.onChangeLoanBalance(value);
              }}
            />
          </div>
        );
      }
    }
  }
}
